// extracted by mini-css-extract-plugin
export default {"pointerDetail":"style_pointerDetail__FYWyH","detailBlock":"style_detailBlock__yBv8R","detail":"style_detail__w7pDH"};